var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4527_323978)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 48,
    fill: "#F7F9FC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0002 52.8696V89.9168C17.0002 90.5103 17.4807 91 18.0698 91H35.1423H60.4166H64.0484H78.9304C79.5195 91 80 90.5103 80 89.9168V72.5111V24.4304V23.9291H69.133C68.0864 23.9291 65.9129 24.0789 65.9129 21.6879L65.8899 11H18.0696C17.4805 11 17 11.484 17 12.0775V21.3249V25.2371V52.8696H17.0002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.9998 72.5111V24.4304V23.9291V23.762C79.9998 23.4508 79.8682 23.399 79.3936 22.9323L67.663 11.6626C67.1083 11.1325 67.0168 11 66.6907 11H65.8899H18.0696C17.4805 11 17 11.484 17 12.0775V89.9168C17 90.5103 17.4805 91 18.0696 91H78.9302C79.5193 91 79.9998 90.5103 79.9998 89.9168V72.5111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9127 21.6879C65.9127 24.0789 68.086 23.9291 69.1328 23.9291H79.9998V23.762C79.9998 23.4508 79.8682 23.399 79.3935 22.9323L67.663 11.6626C67.1082 11.1325 67.0168 11 66.6907 11H65.8899L65.9127 21.6879Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.3935 22.9323L67.663 11.6626C67.1082 11.1325 67.0168 11 66.6907 11H65.8899L65.9127 21.6877C65.9127 24.0787 68.086 23.9289 69.1328 23.9289H79.9998V23.7618C79.9998 23.4508 79.8682 23.399 79.3935 22.9323Z",
    fill: "#E4E8EC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 21,
    width: 32,
    height: 3,
    rx: 1.5,
    fill: "#D2D6DC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 27,
    width: 20,
    height: 3,
    rx: 1.5,
    fill: "#D2D6DC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4527_323978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.1007 67.0742C77.5595 74.7751 84.936 82.1515 84.936 82.1515C84.936 82.1515 85.6688 84.6759 82.1724 88.1723C78.676 91.6687 76.1516 90.9359 76.1516 90.9359C76.1516 90.9359 68.7752 83.5595 61.0743 72.1006",
    fill: "#284A75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8129 78.6238C62.4115 78.6238 72.6248 68.4106 72.6248 55.8119C72.6248 43.2132 62.4115 33 49.8129 33C37.2142 33 27.001 43.2132 27.001 55.8119C27.001 68.4106 37.2142 78.6238 49.8129 78.6238Z",
    fill: "#BCDEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.812 71.3792C58.4099 71.3792 65.3798 64.4093 65.3798 55.8114C65.3798 47.2136 58.4099 40.2437 49.812 40.2437C41.2142 40.2437 34.2443 47.2136 34.2443 55.8114C34.2443 64.4093 41.2142 71.3792 49.812 71.3792Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_4527_323978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.9811 46.1321C44.5501 46.1321 40.1321 50.5501 40.1321 55.9811C40.1321 61.4121 44.5501 65.8302 49.9811 65.8302C55.4121 65.8302 59.8302 61.4121 59.8302 55.9811C59.8302 50.5501 55.4121 46.1321 49.9811 46.1321Z",
    fill: "#65B5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6081 58.4477C53.929 58.7687 53.929 59.2873 53.6081 59.6084C53.4481 59.7684 53.238 59.8488 53.0277 59.8488C52.8176 59.8488 52.6075 59.7684 52.4475 59.6084L49.9811 57.1419L47.5148 59.6084C47.3548 59.7684 47.1447 59.8488 46.9346 59.8488C46.7243 59.8488 46.5142 59.7684 46.3542 59.6084C46.0333 59.2873 46.0333 58.7687 46.3542 58.4477L48.8206 55.9814L46.3542 53.5151C46.0333 53.1941 46.0333 52.6754 46.3542 52.3544C46.6752 52.0336 47.1938 52.0336 47.5148 52.3544L49.9811 54.8209L52.4475 52.3544C52.7685 52.0336 53.2871 52.0336 53.6081 52.3544C53.929 52.6754 53.929 53.1941 53.6081 53.5151L51.1416 55.9814L53.6081 58.4477Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4527_323978"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4527_323978"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white",
    transform: "translate(27 33)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_4527_323978"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.6981,
    height: 19.6981,
    fill: "white",
    transform: "translate(40.1321 46.1321)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/NoData.d536f1a78d6cc85de6ba42e3831708bb.svg";
export { ForwardRef as ReactComponent };